/**
 * Admin AMI Builder Page - Wrapper for AdminAMIBuilder component
 * Provides the AMI Builder functionality within the admin section
 */

import AdminAMIBuilder from '../components/admin/AdminAMIBuilder';

export default function AdminAMIBuilderPage() {
  return <AdminAMIBuilder />;
}